import { render, staticRenderFns } from "./AppCard.vue?vue&type=template&id=3bdaf0ca"
import script from "./AppCard.vue?vue&type=script&lang=ts"
export * from "./AppCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports